import store from "@/store";

export default {
  getEvents(tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/events`);
  },
  getEvent(id, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/events/${id}`);
  },
  getTags(tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/events/_meta/tags`);
  },
  addEvent(addTickets = false, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    const formData = { ...store.state.events.form };
    formData.tenantId = t;
    // The review (glossary "Prüfstatus") is written by its own operations
    // alone (`ApiReviewService`); a save never carries it.
    delete formData.review;
    // An event without an id is created (`POST`), one with an id updated.
    if (!formData.id) {
      return ApiClient.post(
        `api/${t}/events?withTickets=${addTickets}`,
        formData
      );
    }
    return ApiClient.put(`api/${t}/events?withTickets=${addTickets}`, formData);
  },
  deleteEvent(id, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.delete(`api/${t}/events/${id}`);
  },
  duplicateEvent(eventId) {
    return new Promise((resolve, reject) => {
      ApiClient.get(
        `api/${store.getters["tenants/currentTenantId"]}/events/${eventId}`
      )
        .then((getEventResponse) => {
          const event = Object.assign(new Object(), getEventResponse.data);

          delete event.id;
          delete event._id;
          // A copy is a new offer: it starts without the original's review.
          delete event.review;

          event.information.name = `${event.information.name} (Kopie)`;

          if (event) {
            ApiClient.post(
              `api/${store.getters["tenants/currentTenantId"]}/events`,
              event
            )
              .then((putEventResponse) => {
                resolve(putEventResponse);
              })
              .catch((error) => {
                reject(error);
              });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async publicEventCountCheck(tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return (await ApiClient.get(`api/${t}/events/count/check`)).data;
  },
  async getBookedSeatsCount(eventId, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return (await ApiClient.get(`api/${t}/events/${eventId}/count`)).data;
  },
  downloadEventIcal(eventId, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(
      `api/${t}/ical/events/${eventId}?includePast=true&includePrivate=true`
    );
  },
  downloadEventsIcal(ids, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    let query;

    if (ids && ids.length > 0) {
      query = `?ids=${ids.join(",")}`;
    } else {
      query = "";
    }
    return ApiClient.get(`api/${t}/ical/events${query}`);
  },
  getEventFeedUrl(eventId, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    const base = ApiClient.client.defaults.baseURL.replace(/\/+$/, "");
    return `${base}/api/${t}/ical/feed/events/${eventId}`;
  },
  getEventsFeedUrl(ids, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    const base = ApiClient.client.defaults.baseURL.replace(/\/+$/, "");
    let query;
    if (ids && ids.length > 0) {
      query = `?ids=${ids.join(",")}`;
    } else {
      query = "";
    }
    return `${base}/api/${t}/ical/feed/events${query}`;
  },
};
